// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"1f27c615","217":"1f27c615","642":"1f27c615"}[chunkId] + ".chunk.css";
};